/**
 * @packageDocumentation
 * @module      EmcSystemCollection.ts
 * @description Encapsulates the collection of system objects for all active systems.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import EmcSystem from "./EmcSystem";
class EmcSystemCollection {
    static addSystem(emcSystem) {
        let systemId = emcSystem.systemId;
        if (false == EmcSystemCollection.emcSystems.has(systemId)) {
            EmcSystemCollection.emcSystems.set(systemId, new EmcSystem(systemId));
        }
    }
    static getActiveSystemIds() {
        let activeSystemIds = [];
        EmcSystemCollection.emcSystems.forEach(emcSystem => activeSystemIds.push(emcSystem.systemId));
        return activeSystemIds;
    }
    static getSystem(systemId) {
        return EmcSystemCollection.emcSystems.get(systemId);
    }
    static removeSystem(systemId) {
        EmcSystemCollection.emcSystems.delete(systemId);
    }
}
EmcSystemCollection.emcSystems = new Map();
export default EmcSystemCollection;
//# sourceMappingURL=EmcSystemCollection.js.map